"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeLink = exports.removeInvalidCompanyNameChars = void 0;
const regex_1 = require("./validators/regex");
/**
 * Removes invalid characters which are not allowed by the isAllowedCompanyNameCharsOnly regex
 */
const removeInvalidCompanyNameChars = (text) => {
    if (!text) {
        return text;
    }
    return text.replace(regex_1.invalidCompanyNameCharRegex, "");
};
exports.removeInvalidCompanyNameChars = removeInvalidCompanyNameChars;
// sanitize link
const sanitizeLink = (link) => {
    if (!link) {
        return undefined;
    }
    return link.startsWith("http") || link.startsWith("https") ? link : `https://${link}`;
};
exports.sanitizeLink = sanitizeLink;
